import {useState} from "react";
import {createPortal} from "react-dom";

const TOOLTIP_GAP_PX = 4;
// Room a wrapped message needs below the target; with less, the tooltip opens above it instead.
const TOOLTIP_MIN_SPACE_BELOW_PX = 160;

/** Hover handlers plus a tooltip rendered through a portal, so no scrolling container can clip it. */
export default function useHoverTooltip(text) {
    const [position, setPosition] = useState(null);

    const show = event => {
        const rect = event.currentTarget.getBoundingClientRect();
        // Anchor to whichever edges keep the tooltip inside the viewport.
        const vertical = window.innerHeight - rect.bottom >= TOOLTIP_MIN_SPACE_BELOW_PX
            ? {top: rect.bottom + TOOLTIP_GAP_PX}
            : {bottom: window.innerHeight - rect.top + TOOLTIP_GAP_PX};
        setPosition(rect.left > window.innerWidth / 2
            ? {...vertical, right: window.innerWidth - rect.right}
            : {...vertical, left: rect.left});
    };
    const hide = () => setPosition(null);

    const tooltip = position && createPortal(
        <div className="ellipsisTextTooltip" role="tooltip" style={position}>{text}</div>,
        document.body
    );
    return {show, hide, tooltip};
}
